import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

import { useCardContext } from './CardContext';

interface CardFooterProps extends ForwardedHTMLProps {
  children: React.ReactNode;
  className?: string;
}

export const CardFooter = React.forwardRef<HTMLDivElement, CardFooterProps>(
  ({ children, className, ...props }, ref) => {
    const tef = useTEF();
    const forwardedProps = forwardProps(props);
    const cardContext = useCardContext();

    const spacing = cardContext?.spacing || 'default';
    const spacingMap = {
      none: '',
      compact: '-mx-3 -mb-3 px-3',
      default: '-mx-5 -mb-5 px-5',
      spacious: '-mx-8 -mb-8 px-8',
    };

    return (
      <div
        ref={ref}
        className={cn(spacingMap[spacing], 'py-4 border-t', tef.colors.border, className)}
        {...forwardedProps}
        {...props}
      >
        {children}
      </div>
    );
  }
);

CardFooter.displayName = 'CardFooter';
